import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeAttendanceItems} from "../helpers/attendance-items.js";

export default function Attendance({ title, data }) {
    const attendance = makeAttendanceItems(data);

    return (
        <InfoGrid title={title} items={attendance} />
    )
}